/**
 * IMPORT WISHLIST
 * 
 * Gestion du drag&drop et du chargement du fichier .csv
 * module de gestion de l'importation de wishlist
 * via une popin dans
 * la partie PRO de l'espace mon compte
 */
import $ from "jquery";
const utils = require('../utils').default;
import { services } from "../../../../helpers/service";
import { dialog } from "../../../../components/dialog";

const WLImport = (function () {
    const DOM_IMPORT = 'popin-import';
    const DOM_IMPORT_POPIN = `[data-js-dialog-id="${DOM_IMPORT}"]`;
    const DOM_IMPORT_INPUT = `${DOM_IMPORT_POPIN} .js-import-input`;
    const DOM_DROP_ZONE = `${DOM_IMPORT_POPIN} .js-drop-zone`;
    const DOM_IMPORT_LOADER = `${DOM_IMPORT_POPIN} .spinner`;
    const DOM_IMPORT_ERROR = `${DOM_IMPORT_POPIN} .form-ajax-error p`;
    const DOM_IMPORT_WL_EXIST = `${DOM_IMPORT_POPIN} .js-wishlist-import-exist`;
    
    let $domCurrentDropElement;
    let $input;
    let importData = {};

    /**
     * IMPORT LOADER TOGGLER
     */
    const importLoaderToggler = () => {
        $(DOM_IMPORT_LOADER).toggleClass("disabled");
    };
    /**
     * IMPORT WISHILIST SAVE
     * 
     * enregistrement de la wishlist
     * @returns 
     */
    const importWishilistSave = () => {
        $(DOM_IMPORT_WL_EXIST).hide();
        if (window.WL.isWishlistExist(importData.name)) {
            // si existe on ecrase la WL
            window.WL.emptyWishlist(importData.name)
            window.WL.addToWishlist(importData.list, importData.name);
        } else {
            // creation
            window.WL.createWishlist(importData.name);
            window.WL.addToWishlist(importData.list, importData.name);
        };
        utils.debug('IMPORT WISHILIST SAVE', {liste:importData.list, name:importData.name});   
        utils.dispatchCustomEvent('TRACKERS_WISHLIST_IMPORT', {format: importData.fileFormat, type: importData.type});
        /**
         * Generation du tracker 
         * TRACKER_WISHLIST_PRODUCTS_ADD_TO_CART
         */
        window.WL.getWishlistFlattenProductsFromList(importData.name).then((products) => {
            utils.dispatchCustomEvent('TRACKER_WISHLIST_PRODUCTS_ADD_TO_CART', {
                listLabel: importData.name,
                listCategory: utils.getContext(),
                products
            });
        })
        popinClose();
        return;
    };
    /**
     * IMPORT WISHILIST SUCCESS
     * 
     * test avant l'enregistrement.
     * Si WL exist, demande de comfirmation avant écrasement
     * @param {string} list 
     * @param {string} name 
     * @param {string} type 
     * @returns 
     */
    const importWishilistSuccess = (list, name, type) => {
        importData.list = list;
        importData.name = name;
        importData.type = type;
        if (!/pro|part/.test(importData.type)) {
            console.error('Type de wishlist autre que "pro" ou "part":', importData.type);
            return false;
        }

        // test si la nouvelle WL existe déjà
        if (window.WL.isWishlistExist(importData.name)) {
            $(DOM_IMPORT_WL_EXIST).show().one('click', function () {
                importWishilistSave()
            });
        } else {
            importWishilistSave();
        }
        $(DOM_DROP_ZONE ).removeClass('active');
        importLoaderToggler();
    }
    /**
     * IMPORT WISHLIST
     * 
     * importation via service
     * @param {event} event
     * @returns 
     */
    const importWishlist = (event) => {
        // no data
        $input = event.currentTarget;
        if (!$input.value) return;
        importLoaderToggler();
        let formData = new FormData();
        formData.append('file', $input.files[0]);
        importData.fileFormat = $input.files[0].name.split('.').pop();

        return services.use('wishlistimport', formData, false).then(function(result) {
            if (result.erreur_descr !== undefined) {
                utils.debug('WL IMPORT WISHLIST', 'erreur lors de l\'importation');  
                $(DOM_IMPORT_ERROR).text(result.erreur_descr).parent().show();
            } else {
                utils.debug('WL IMPORT WISHLIST', result.datas);  
                importWishilistSuccess(result.datas.elements, result.datas.name, result.datas.type)
            }
        }).catch(function(result) {
            utils.debug('WL IMPORT WISHLIST', 'erreur lors de l\'importation'); 
            $(DOM_IMPORT_ERROR).text(result.responseText).parent().show();
            importLoaderToggler();
        });
    };
    /**
     * gestion des class de l'element de drag&drop
     * @param {event} event 
     */
    var dragAndDropClass = function(event) {
        event.stopPropagation();
        let $target = $(DOM_DROP_ZONE);

        if (event.type === 'dragenter') {
            $domCurrentDropElement = $(event.target);
            $target.addClass('active').removeClass('dropped');
        }
        if (event.type === 'dragleave' && $(event.target).is($domCurrentDropElement)) {
            $target.removeClass('active');
        }
        if (event.type === 'drop') {
            $target.addClass('dropped');
        }
    };
    /**
     * POPIN CLOSE (func)
     * 
     * Fermeture de la popin creation d'adresse
     */
    const popinClose = (event) => {
        dialog.close(DOM_IMPORT);
    }
    /**
     * INIT (func)
     */
    const init = () => {
        utils.debug('WL IMPORT', 'initialisation');  
        // event sur l'input de selection du fichier
        $(DOM_IMPORT_INPUT).on('change', importWishlist);
        // gestion des class sur l'element de drag&drop
        $('body').on('dragenter drop dragleave dragover', dragAndDropClass);
    };
    return {init:init}
})();
export default WLImport;